<template lang="html">
  <div :class="['rating__starts', 'is-' + state]">
    <star-rating v-model="value" :increment='increment' :max-rating='maxRating' :starSize='starSize' :read-only='readOnly' :show-rating='showRating'></star-rating>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating';

export default {
  name: 'input-star',
  props: {
    showRating: {
      type: Boolean,
    },
    readOnly: {
      type: Boolean,
    },
    starSize: {
      type: Number,
    },
    increment: {
      type: Number,
    },
    maxRating: {
      type: Number,
    },
    model: {
      type: Number,
    },
    state: {
      type: String,
      default: null,
    },
  },
  components: {
    StarRating,
  },
  computed: {
    value: {
      get() {
        return this.model;
      },
      set(value) {
        this.$emit('update:model', value);
      },
    },
  },
  data() {
    return {
      rating: 0,
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.rating__starts {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  &__rating {
    margin: 15px 10px;
    font-size: 1rem;
  }
}
</style>
